import timelineCss from "react-calendar-timeline/dist/style.css?inline"
import sharedCss from "../../../../shared/index.scss?inline"
import timelineGraphCss from "vis-timeline/dist/vis-timeline-graph2d.min.css?inline"

/**
 * Aggregated CSS injected into the Shadow DOM for embedded sections.
 * Add additional shared/global SCSS imports here to make them available
 * inside the shadow root.
 */
export const shadowGlobalCss = `
${timelineCss}
${timelineGraphCss}
${sharedCss}

/* Consistent bottom padding for all section content */
#section-body {
  padding-bottom: 16px;
}

/* Text selection visibility and selectability */
:host ::selection,
:host *::selection {
  background-color: rgba(57, 174, 210, 0.3) !important;
  color: inherit !important;
}

:host ::-moz-selection,
:host *::-moz-selection {
  background-color: rgba(57, 174, 210, 0.3) !important;
  color: inherit !important;
}

:host *,
.chakra-text,
.chakra-heading,
p,
span,
h1,
h2,
h3,
h4,
h5,
h6 {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}
`
